/* unplugin-vue-components disabled */var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bank-card-icons",class:_vm.$mq},[_c('div',{staticClass:"bank-card-icons__item",class:_vm.$mq},[_c('Wechat')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }